module.exports = __webpack_public_path__ + "static/img/14.6dd0c79.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/eng/14.png
// module id = 4Qdg
// module chunks = 0